import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { BankCardStore } from './+state/bank-card.store';
import { BankCardService } from './service/bank-card.service';

export function provideBankCard(): EnvironmentProviders {
  return makeEnvironmentProviders([BankCardService, BankCardStore]);
}
